module.exports = __webpack_public_path__ + "assets/chevin-light.50aef4a46332728d9b9d24862704f2e4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OP/chevin-light.woff2
// module id = 52
// module chunks = 0